import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from 'panamera-react-ui';
import CookieManager from "../../Utils/CookieManager";
var css = {
  "widget": "oalp-1H0U1",
  "mobile": "oalp-27Pda",
  "cta": "oalp-3N4xS",
  "backIcon": "oalp-2DG9A"
};
import DependencyManager from "../../DependencyManager";
import StaticItem from "../../Components/StaticItem/StaticItem";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import UserSession from "../../Utils/UserSession";
import { withRouter } from "../../Helpers/withRouter";
import useErrorCookie from "../../CustomHooks/useErrorCookie/useErrorCookie";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING, FLOW_TYPES, SELLER_STATE_COOKIE } from "../../Constants/evaluation";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import withConfig from "./../../ComponentDependency/withConfig";
export var StaticImageWithCTA = function StaticImageWithCTA(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    image = _ref$data.image,
    cta = _ref$data.cta,
    title = _ref$data.title,
    formatHtmlText = _ref$data.formatHtmlText,
    subtitle = _ref$data.subtitle,
    formatTextWithIcon = _ref$data.formatTextWithIcon,
    metadata = _ref.metadata,
    handleIconClick = _ref.handleIconClick,
    track = _ref.track,
    locationId = _ref.locationId,
    ReactObserver = _ref.ReactObserver,
    widgetKey = _ref.widgetKey,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    onCTAClick = _ref.onCTAClick,
    landingURLSearch = _ref.landingURLSearch,
    dynamicParamsValues = _ref.dynamicParamsValues,
    config = _ref.config,
    params = _ref.params;
  var _ref2 = metadata || {},
    style = _ref2.style,
    showBackIcon = _ref2.showBackIcon;
  var PanameraConstants = DependencyManager.getDependency('constants');
  useErrorCookie({
    widgetName: name
  });
  var handleChange = useCallback(function (inView) {
    var _a;
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: widgetKey,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        select_from: metadata.trackingInfo.impressionEvent.selectFrom,
        reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL,
        flow_type: FLOW_TYPES.NO_DRAFT,
        chosen_option: ((_a = metadata.trackingInfo.impressionEvent) === null || _a === void 0 ? void 0 : _a.chosenOption) || ''
      });
      track(metadata.trackingInfo.impressionEvent.name, trackingInfo);
    }
  }, [browsingMode, locationId, origin, track, widgetKey, metadata]);
  var backIconClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var evalState = UserSession.getUserEvaluationState();
    if (evalState === EVALUATION_STATES.CALLBACK_REQUESTED) {
      if (handleIconClick) {
        handleIconClick(EVALUATION_STATES.CALLBACK_REQUESTED);
        trackingHelper({
          eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS_ERROR_CALLBACK,
          track: track,
          locationId: locationId,
          origin: origin,
          select_from: EVALUATION_STATES_TRACKING.CALLBACK_COMPLETE,
          landingURLSearch: landingURLSearch,
          params: params,
          config: config.get()
        });
      }
    }
  }, [handleIconClick, landingURLSearch, locationId, origin, track, params, config]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer",
    triggerOnce: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.widget, css[PanameraConstants.platform]),
    style: style
  }, showBackIcon ? /*#__PURE__*/React.createElement("span", {
    className: css.backIcon,
    onClick: backIconClick
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrowLeft",
    size: 24
  })) : null, /*#__PURE__*/React.createElement(StaticItem, {
    image: image,
    title: title,
    formatHtmlText: formatHtmlText,
    subtitle: subtitle,
    formatTextWithIcon: formatTextWithIcon,
    cta: cta,
    widgetName: name,
    locationId: locationId,
    track: track,
    ctaWrapperClassName: css.cta,
    metadata: metadata,
    handleOnClick: onCTAClick,
    dynamicParamsValues: dynamicParamsValues,
    handleIconClick: handleIconClick
  })));
};
export default compose(withComponentDependency, withRouter, withConfig)(StaticImageWithCTA);